import React from "react";
import { Typography, Modal, Button, Icon } from "@plum-xoxo/admin-dsm";
import styled from "styled-components";
import "./KYBSubmitInfoModal.scss";

const CustomNumber = styled(Typography).attrs()`
  color: ${(props) => props.theme.palette.primary.c02};
  background-color: ${(props) => props.theme.palette.primary.c00};
  border-radius: 100%;
  padding: 4px 8px 4px 8px;
`;

export default function KYBSubmitInfoModal({
  showModal,
  handleSave,
  closeModal,
}) {
  const items = [
    "This allows us to validate your corporate credentials and improve the security of your account.",
    "Any limitations around wallet recharge are eliminated after verification.",
    "This helps us reduce the chance of a fraudulent transaction from your account.",
  ];

  return (
    <Modal
      isOpen={showModal}
      className="KYBSubmitInfoModal"
      style={{ width: "676px" }}
    >
      <Typography component="div" className="d-flex justify-content-between">
        <Typography.H3 color="dark" shade="c300">
          Why you need to submit account verification details?
        </Typography.H3>
        <Icon
          iconName="Close"
          color="dark"
          shade="c300"
          size="s"
          onClick={() => handleSave()}
        />
      </Typography>

      <Typography color="dark" shade="c200" className="mt-24">
        {items ? (
          <div>
            {items.map((item, index) => {
              return (
                <p key={index} className="normal d-flex align-items-center ">
                  <CustomNumber component="span" className="px-8 mb-0">
                    <Typography.LabelText color="primary" shade="c02">
                      {index + 1}
                    </Typography.LabelText>
                  </CustomNumber>{" "}
                  <Typography
                    component="span"
                    color="dark"
                    shade="c300"
                    className="mb-0 ml-16"
                  >
                    {item}
                  </Typography>
                </p>
              );
            })}
          </div>
        ) : null}
      </Typography>

      <hr className="my-24" />

      <Typography component="div" className="text-right">
        <Button
          variant="outlined"
          onClick={() => {
            handleSave();
          }}
        >
          Ok, Got it
        </Button>
      </Typography>
    </Modal>
  );
}
